import React, { useState } from 'react'

export function SelectEmployee({ employees = [], selectedEmployees = [], onSelect, multiple = true }) {
	const [search, setSearch] = useState('')
	const [level, setLevel] = useState('')
	const [area, setArea] = useState('')

	const simpleEmployees = employees.map(emp => ({
		id: emp.id,
		name: emp.name,
		area: emp.area?.profileArea || '',
		level: emp.level?.PositionN || '',
	}))

	const filtered = simpleEmployees.filter(
		emp => emp.name.toLowerCase().includes(search.toLowerCase()) && (level ? emp.level === level : true) && (area ? emp.area === area : true)
	)

	const handleCheck = id => {
		let newSelected
		if (selectedEmployees.includes(id)) {
			newSelected = selectedEmployees.filter(eid => eid !== id)
		} else {
			if (multiple) {
				newSelected = [...selectedEmployees, id]
			} else {
				newSelected = [id]
			}
		}
		onSelect(newSelected)
	}

	return (
		<div>
			<div style={{ maxHeight: 320, overflowY: 'auto' }}>
				<table className='tw-w-full tw-text-sm'>
					<thead>
						<tr className='border-bottom'>
							<th className='tw-py-2 tw-px-2 tw-text-left'>
								<input
									className='tw-cursor-pointer'
									type='checkbox'
									checked={
										multiple
											? filtered.length > 0 && filtered.every(emp => selectedEmployees.includes(emp.id))
											: filtered.length === 1 && selectedEmployees.includes(filtered[0]?.id)
									}
									onChange={e => {
										if (multiple) {
											if (e.target.checked) {
												const allIds = filtered.map(emp => emp.id)
												onSelect(Array.from(new Set([...selectedEmployees, ...allIds])))
											} else {
												onSelect(selectedEmployees.filter(id => !filtered.some(emp => emp.id === id)))
											}
										} else {
											if (e.target.checked && filtered.length === 1) {
												onSelect([filtered[0].id])
											} else {
												onSelect([])
											}
										}
									}}
									disabled={!multiple}
								/>
								<span className='tw-ml-2 tw-text-gray-500'>Colaborador</span>
							</th>
							<th className='tw-py-2 tw-px-2 tw-text-left tw-text-gray-500'>Nível</th>
							<th className='tw-py-2 tw-px-2 tw-text-left tw-text-gray-500'>Área</th>
						</tr>
					</thead>
					<tbody>
						{filtered.map(emp => (
							<tr key={emp.id} className='border-bottom hover:tw-bg-gray-50'>
								<td className='tw-py-2 tw-px-2'>
									<input
										type='checkbox'
										checked={selectedEmployees.includes(emp.id)}
										onChange={() => handleCheck(emp.id)}
										className='tw-cursor-pointer'
										disabled={!multiple && selectedEmployees.length === 1 && !selectedEmployees.includes(emp.id)}
									/>
									<span className='tw-ml-2 tw-font-semibold'>{emp.name}</span>
								</td>
								<td className='tw-py-2 tw-px-2'>{emp.level}</td>
								<td className='tw-py-2 tw-px-2'>{emp.area}</td>
							</tr>
						))}
						{filtered.length === 0 && (
							<tr>
								<td colSpan={3} className='tw-text-center tw-text-gray-400 tw-py-4'>
									Ningún colaborador encontrado.
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	)
}
